import { render, staticRenderFns } from "./NumberLabel.vue?vue&type=template&id=2122e249&"
import script from "./NumberLabel.vue?vue&type=script&lang=js&"
export * from "./NumberLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports